<template>
  <vf-media-gallery :items="galleryItems" pagination :product-id @zoom="onZoom">
    <template #default="{ i }">
      <slot v-bind="{ i }">
        <div
          v-if="i === 0 && (hasBreadcrumbs || hasReviews)"
          class="absolute inset-x-0 top-15 flex items-start gap-4 px-3 py-4 between lg:hidden"
        >
          <pdp-section-breadcrumbs
            v-if="hasBreadcrumbs"
            class="max-w-full w-fit rounded-xs bg-brand-5 bg-op-50 px-1 backdrop-blur-xs wrap"
          />
          <pdp-section-reviews-summary v-if="hasReviews" class="ml-a shrink-0 py-1" />
        </div>
        <!-- container for social proof injection -->
        <div
          v-if="i === ($viewport.lg ? 1 : 0)"
          id="below-price-info"
          class="pointer-events-none absolute bottom-0 left-0 z-1 m-4 lg:bottom-a lg:left-a lg:right-0 lg:top-0 empty:hidden"
        />

        <div class="absolute right-0 top-0 mr-3 mt-15 f-col items-start gap-4 lg:m-6">
          <p
            v-if="modelMeasurements && i === (galleryItems.length > 2 ? 2 : 0)"
            class="pointer-events-none w-fit bg-white bg-op-70 p-2 body-4 backdrop-blur-md"
          >
            {{ modelMeasurements[0] }}
          </p>
        </div>
      </slot>
    </template>
  </vf-media-gallery>
</template>

<script lang="ts" setup>
const { galleryItems, modelMeasurements, onZoom, product, productId, reviewsSummaryData } = usePdp()

const hasBreadcrumbs = computed(() => Boolean(product.value?.breadcrumbs?.length))
const hasReviews = computed(() => Boolean(reviewsSummaryData.value?.rollup?.reviewCount))
</script>
